/**
 * Converts a YYYY-MM-DD string to a Date at midnight UTC.
 * Used for API payloads that expect a Date at the start of day.
 */
export function toMidnightUtc(dateStr: string): Date {
  const parts = dateStr.split('-');
  const year = Number(parts[0]);
  const month = Number(parts[1]);
  const day = Number(parts[2]);
  return new Date(Date.UTC(year, month - 1, day, 0, 0, 0, 0));
}

/**
 * Converts a YYYY-MM-DD string to a Date at end-of-day UTC
 * (23:59:59.999). Used for expiration date payloads.
 */
export function toEndOfDayUtc(dateStr: string): Date {
  const parts = dateStr.split('-');
  const year = Number(parts[0]);
  const month = Number(parts[1]);
  const day = Number(parts[2]);
  return new Date(Date.UTC(year, month - 1, day, 23, 59, 59, 999));
}
